import { useEffect } from 'react';

// Google Analytics utility functions
export const gtag = (...args) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...args);
  }
};

// Track page views
export const trackPageView = (pageTitle, pageLocation) => {
  gtag('config', 'G-6E24KPMK4B', {
    page_title: pageTitle,
    page_location: pageLocation,
    send_page_view: true
  });
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value
  });
};

// Track booking events
export const trackBooking = (packageName, packageType, location) => {
  trackEvent('booking_initiated', 'engagement', `${packageType}_${packageName}`, 1);
  trackEvent('location_selected', 'engagement', location, 1);
};

// Track package selection
export const trackPackageSelection = (packageName, packageType) => {
  trackEvent('package_selected', 'engagement', `${packageType}_${packageName}`, 1);
};

// Track contact form submissions
export const trackContactForm = (formType) => {
  trackEvent('form_submitted', 'engagement', formType, 1);
};

// Track photo/film views
export const trackMediaView = (mediaType, mediaName) => {
  trackEvent('media_viewed', 'engagement', `${mediaType}_${mediaName}`, 1);
};

// Track social media clicks
export const trackSocialClick = (platform) => {
  trackEvent('social_click', 'engagement', platform, 1);
};

// Track phone number clicks
export const trackPhoneClick = (phoneNumber) => {
  trackEvent('phone_click', 'engagement', phoneNumber, 1);
};

// Track WhatsApp clicks
export const trackWhatsAppClick = () => {
  trackEvent('whatsapp_click', 'engagement', 'whatsapp_booking', 1);
};

// Google Analytics Component
const GoogleAnalytics = () => {
  useEffect(() => {
    // Initialize Google Analytics if not already loaded
    if (typeof window !== 'undefined' && !window.gtag) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-6E24KPMK4B';
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', 'G-6E24KPMK4B', {
          page_title: document.title,
          page_location: window.location.href,
          send_page_view: true
        });
      };
    }

    // Track initial page view
    if (typeof window !== 'undefined' && window.gtag) {
      trackPageView(document.title, window.location.href);
    }
  }, []);

  return null;
};

export default GoogleAnalytics;
